<mat-card class="card">
  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex-col">
        <mat-form-field class="fxflex-1-0" style="flex-basis: 70%">
          <mat-label i18n="@@name">Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field class="fxflex-1-0" style="flex-basis: 70%">
          <mat-label i18n>Key</mat-label>
          <input matInput formControlName="key" />
        </mat-form-field>
        <mat-form-field class="fxflex-1-0" style="flex-basis: 70%">
          <mat-label i18n="@@sort">Sort</mat-label>
          <input matInput formControlName="sort" />
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label i18n>select attribute type</mat-label>
        <mat-select formControlName="productAttributeType">
          @for (type of ProductCategoriesAtt | keyvalue; track type) {
          <mat-option [value]="+type.key">{{ type.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
      Close
    </button>
    <button
      matButton="elevated"
      color="accent"
      (click)="onSave()"
      [disabled]="!form.valid || form.pristine"
      i18n="@@buttonSave"
    >
      Save
    </button>
  </mat-card-actions>
</mat-card>
